<template>
    <div id="external-access-modal" class="overlay">
        <div class="box">
            <h2 style="margin:0 0 10px">{{toLocal('fm_driver_app.open_from_app')}}</h2>
            <p>{{toLocal('fm_driver_app.open_from_app_2')}}</p>
        </div>
    </div>
</template>
<script>
export default {

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
<style lang="scss" scoped>
.overlay{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    z-index: 2147483647;
    display : none;
    align-items: center;
    justify-content: center;
}
.box{
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background:#fff;
    padding:20px ;
    border-radius: 8px;
    text-align: center;
}
</style>